import endpoints from "@/endpoints.json";
import { ISeason } from "@/zodTypes";

const getAllMetadata: () => Promise<ISeason[]> = async () => {
  const metadata: ISeason[] = await fetch(`${endpoints.metadata}/all.json`).then((res) => res.json());

  return metadata;
};

export default getAllMetadata;
